/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/components/InteractiveEducationLoading.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */
import { useEffect, useState } from 'react';
import { keyframes } from 'styled-components';
import styled from 'foundations-theming/utils';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { AILoader } from 'ai-components-ui-library/components/loading/AILoader';
import { AISkeleton } from 'ai-components-ui-library/components/loading/AISkeleton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const fadeInOut = keyframes(["0%,100%{opacity:0;transform:translateY(10px);}10%,90%{opacity:1;transform:translateY(0);}"]);
const ellipsisAnimation = keyframes(["0%,20%{content:'.';}40%{content:'..';}60%,100%{content:'...';}"]);
const AnimatedCarouselText = styled.span.withConfig({
  displayName: "InteractiveEducationLoadingmigrated__AnimatedCarouselText"
})(["display:inline-block;animation:", " 4s ease-in-out infinite;"], fadeInOut);
const AnimatedDots = styled.span.withConfig({
  displayName: "InteractiveEducationLoadingmigrated__AnimatedDots"
})(["display:inline-block;width:1.5em;text-align:left;&::after{content:'...';animation:", " 1.5s steps(3,end) infinite;}"], ellipsisAnimation);
const InteractiveEducationLoading = ({
  mainText,
  carouselTexts = []
}) => {
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  useEffect(() => {
    if (carouselTexts.length <= 1) return;
    const interval = setInterval(() => {
      setCurrentTextIndex(prevIndex => (prevIndex + 1) % carouselTexts.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [carouselTexts.length]);

  // Fallback to shimmer skeleton when either mainText or carouselTexts is missing
  if (!mainText || carouselTexts.length === 0) {
    return /*#__PURE__*/_jsxs(View, {
      "data-test-id": "interactive-education-loading-shimmer",
      children: [/*#__PURE__*/_jsx(View, {
        children: /*#__PURE__*/_jsx(AISkeleton, {
          height: "40px",
          width: "10%"
        })
      }), /*#__PURE__*/_jsx(View, {
        children: /*#__PURE__*/_jsx(AISkeleton, {
          height: "25px",
          width: "65%"
        })
      }), /*#__PURE__*/_jsx(View, {
        marginBlock: "200",
        children: /*#__PURE__*/_jsx(AISkeleton, {
          height: "50px",
          shape: "pill",
          width: "100%"
        })
      }), /*#__PURE__*/_jsx(View, {
        marginBlock: "200",
        children: /*#__PURE__*/_jsx(AISkeleton, {
          height: "50px",
          shape: "pill",
          width: "100%"
        })
      }), /*#__PURE__*/_jsx(View, {
        marginBlock: "200",
        children: /*#__PURE__*/_jsx(AISkeleton, {
          height: "50px",
          shape: "pill",
          width: "100%"
        })
      }), /*#__PURE__*/_jsx(View, {
        marginBlock: "200",
        children: /*#__PURE__*/_jsx(AISkeleton, {
          height: "50px",
          shape: "pill",
          width: "100%"
        })
      })]
    });
  }
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    "data-test-id": "interactive-education-loading",
    flexDirection: "column",
    justifyContent: "center",
    minBlockSize: "400px",
    children: [/*#__PURE__*/_jsx(View, {
      marginBlockEnd: "600",
      children: /*#__PURE__*/_jsx(AILoader, {
        size: "lg"
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "400",
      children: /*#__PURE__*/_jsxs(Text, {
        textAlign: "center",
        typography: "heading-400",
        children: [mainText, /*#__PURE__*/_jsx(AnimatedDots, {})]
      })
    }), carouselTexts.length > 0 && /*#__PURE__*/_jsx(View, {
      minBlockSize: "24px",
      children: /*#__PURE__*/_jsx(Text, {
        textAlign: "center",
        typography: "body-400",
        children: /*#__PURE__*/_jsx(AnimatedCarouselText, {
          children: carouselTexts[currentTextIndex]
        }, currentTextIndex)
      })
    })]
  });
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/components/InteractiveEducationLoading.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export default InteractiveEducationLoading;